/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class ApiConfiguration {
  rootUrl: string = 'https://dev.dashypay.com/erp-api';
}

/**
 * Parameters for `ErpClientApi.forRoot()`
 */
export interface ApiConfigurationParams {
  rootUrl?: string;
}
